import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {
  SingleScreenMessageActiveTable,
  SingleScreenMessageCompletedTable,
} from './SingleScreenMessageTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const SingleScreenMessageTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});
  const tabs = {
    active: {
      label: 'Active',
      view: <SingleScreenMessageActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <SingleScreenMessageCompletedTable searchValue={searchValue} />,
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
